const coupons = {
  coupon1: {
    discount: 200,
    code: 'GERTE4T5T'
  },
  coupon2: {
    discount: 100000,
    code: 'SOMEOTHERCODE'
  },
  coupon3: {
    discount: 400,
    code: 'ANOTHERCODE'
  },
  coupon4: {
    discount: 500,
    code: 'YETANOTHERCODE'
  }
}

export default coupons
